import { useEffect } from "react";
import { useAppDispatch } from "../../../reduxToolkit/hooks";
import { fetchCategoryApiData, fetchProductApiData } from "../../../reduxToolkit/reducers/productSlice";
import LogoSection from "../common/LogoSection";
import Newsletter from "../common/Newsletter";
import AboutAndJobOpening from "./aboutAndJobOpening";
import Company from "./Company";
import InterviewQuestion from "./InterviewQuestion";
import JobCities from "./JobCities";
import JobHomeSection from "./JobHomeSection";

const JobDemo3Container = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchProductApiData());
    dispatch(fetchCategoryApiData());
  }, [dispatch]);
  return (
    <>
      <JobHomeSection />
      <LogoSection swiperClass="logo-job3-slider" title="World best companies are hiring on hire up" />
      <AboutAndJobOpening />
      <JobCities />
      <Company />
      <InterviewQuestion />
      <Newsletter type="job_demo3" />
    </>
  );
};

export default JobDemo3Container;
